<template>
  <div class="flex flex-col bg-block shadow-primaryBlock rounded overflow-hidden
              px-8 py-8 lg:px-12 lg:pt-13 lg:pb-10">
    <SpaceSettingsGeneral class="mb-8" @settingsChanged="saveSettings($event)"/>
    <div class="flex justify-between items-center mt-auto">
      <ChangesSaved ref="saveSuccess"/>
      <div class="flex items-center space-x-4">
        <LeaveBtn v-if="!currentUserIsCreator"/>
        <ArchiveBtn v-if="currentUserIsAdmin"
                    :space="$store.state.space.current_space.data"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import SpaceSettingsGeneral from "@/components/cabinet/SpaceSettings/SpaceSettings/SpaceSettingsGeneral";
import ChangesSaved from "@/components/common/ChangesSaved";
import BaseButton from "@/components/UI/BaseButton";
import ArchiveBtn from "@/components/cabinet/SpaceSettings/SpaceSettings/ArchiveBtn";
import LeaveBtn from "@/components/cabinet/SpaceSettings/SpaceSettings/LeaveBtn";

export default {
  name: "SpaceSettings",
  components: {
    LeaveBtn,
    ArchiveBtn,
    BaseButton,
    SpaceSettingsGeneral,
    ChangesSaved,
  },
  computed: {
    ...mapGetters('space', ['currentUserIsAdmin', 'currentUserIsCreator'])
  },
  methods: {
    ...mapActions('space', ['updateSpace']),
    ...mapActions('space/access', ['fetchSpaceMembers']),
    ...mapMutations('space', ['setCurrentSpaceInfo']),
    async saveSettings(payload) {
      try {
        const res = await this.updateSpace(payload)
        if (res.body.success) {
          this.setCurrentSpaceInfo(res.body.data);
          this.$refs.saveSuccess.showSaved();
        }
      } catch (e) {
        throw e;
      }
    }
  },
  async created() {
    await this.fetchSpaceMembers();
  },
}
</script>

<style scoped lang="scss">
.blue-block {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 43px;
  padding: 30px 50px 44px;


  .form__radio-tiles {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 26px;

    .invite-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 24px;


      &__icon {
        text-align: center;
        cursor: pointer;
        background: #FFFFFF;
        border: 1px solid #D3D7DC;
        box-sizing: border-box;
        border-radius: 3px;
        min-width: 98px;
        height: 86px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        color: #486680;
        transition: all .2s;

        svg {
          margin-bottom: 10px;
          font-size: 30px;
        }

        .text {
          width: 100%;
          font-family: Open Sans, sans-serif;
          font-weight: bold;
          font-size: 11px;
          line-height: 15px;
          text-align: center;
          text-transform: uppercase;
        }
      }

      &__description {
        text-align: left;

        .name {
          font-weight: bold;
          font-size: 14px;
          line-height: 16px;
          color: #393939;
          margin-bottom: 10px;
        }

        .text {
          font-size: 12px;
          line-height: 14px;
          color: #818181;
          margin-bottom: 0;

          .bold {
            font-weight: bold;
            display: block;
          }
        }
      }
    }
  }
}

</style>
